import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

import card1 from "../../../assets/img/home/certifications/card1.webp";
import card2 from "../../../assets/img/home/certifications/card2.webp";
import card3 from "../../../assets/img/home/certifications/card3.webp";
import card4 from "../../../assets/img/home/certifications/card4.webp";
import card5 from "../../../assets/img/home/certifications/card5.webp";
import card6 from "../../../assets/img/home/certifications/card6.webp";
import card7 from "../../../assets/img/home/certifications/card7.webp";
import card8 from "../../../assets/img/home/certifications/card8.webp";
import card9 from "../../../assets/img/home/certifications/card9.webp";
import card10 from "../../../assets/img/home/certifications/card10.webp";
import card11 from "../../../assets/img/home/certifications/card11.webp";
import card12 from "../../../assets/img/home/certifications/card12.webp";
import card13 from "../../../assets/img/home/certifications/card13.webp";
import card14 from "../../../assets/img/home/certifications/card14.webp";
import card15 from "../../../assets/img/home/certifications/card15.webp";
import card16 from "../../../assets/img/home/certifications/card16.webp";
import card17 from "../../../assets/img/home/certifications/card17.webp";
import card18 from "../../../assets/img/home/certifications/card18.webp";
import card19 from "../../../assets/img/home/certifications/card19.webp";
import card20 from "../../../assets/img/home/certifications/card20.webp";
import card21 from "../../../assets/img/home/certifications/card21.webp";
import card22 from "../../../assets/img/home/certifications/card22.webp";

const certifications = [
  { className: "card1", i18nKey: "cert_sassmaq", img: card1 },
  { className: "card2", i18nKey: "cert_atuacao", img: card2 },
  { className: "card3", i18nKey: "cert_iso9001", img: card3 },
  { className: "card4", i18nKey: "cert_iso14001", img: card4 },
  { className: "card5", i18nKey: "cert_iso45001", img: card5 },
  { className: "card6", i18nKey: "cert_licenca", img: card6 },
  { className: "card7", i18nKey: "cert_letpp", img: card7 },
  { className: "card8", i18nKey: "cert_lac", img: card8 },
  { className: "card9", i18nKey: "cert_cr", img: card9 },
  { className: "card10", i18nKey: "cert_anvisa", img: card10 },
  { className: "card11", i18nKey: "cert_pf", img: card11 },
  { className: "card12", i18nKey: "cert_exercito", img: card12 },
  { className: "card13", i18nKey: "cert_mapa", img: card13 },
  { className: "card14", i18nKey: "cert_olhovivo", img: card14 },
  /* { className: "card15", i18nKey: "cert_gpmh", img: card15 }, */
  { className: "card16", i18nKey: "cert_laco", img: card16 },
  { className: "card17", i18nKey: "cert_namao", img: card17 },
  { className: "card18", i18nKey: "cert_pellets", img: card18 },
  { className: "card19", i18nKey: "cert_plvb", img: card19 },
  { className: "card20", i18nKey: "cert_plvb_ouro", img: card20 },
  { className: "card21", i18nKey: "cert_tfs", img: card21 },
  { className: "card22", i18nKey: "cert_ecovadis", img: card22 },
];

function HomeCertifications() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <section>
      <VisibilitySensor onChange={onChange} partialVisibility minTopValue={200}>
        <div className="homeCertifications">
          <div className="homeCertificationsText">
            <h1 className={`${isVisible ? "visible" : ""}`}>
              {t("certifications_title")}{" "}
              <span className={`${isVisible ? "visible" : ""}`}>
                {t("certifications_title_span")}
              </span>
            </h1>
            <p className={`${isVisible ? "visible" : ""}`}>
              {t("certifications_text")}
            </p>
          </div>
          <div className="homeCertificationsCards">
            {certifications.map(({ className, i18nKey, img }) => (
              <div
                key={className}
                className={`${className} card ${isVisible ? "visible" : ""}`}
              >
                <img src={img} alt="" width={"100px"} height={"111px"} />
                <div className="cardText">
                  <p>{t(i18nKey)}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </VisibilitySensor>
    </section>
  );
}

export default HomeCertifications;
